module.exports = __webpack_public_path__ + "img/2C.136dab43.png";